import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Calculator from '@components/Utilities/Calculator';
import { currencyFormatter } from '@utils/Numbers';
interface ModalCashCalculatorProps {
    modalCashCalculator: OpenModalHookType;
    total: number;
    onContinue: () => void;
}
export const ModalCashCalculator: React.FunctionComponent<ModalCashCalculatorProps> = (props: any) => {
    const { modalCashCalculator, total, onContinue } = props;
    const [amount, setAmount] = useState<number>(0);
    const [change, setChange] = useState<number>(0);
    const [totalAmount] = useState<boolean>(false);

    const handleClose = () => {
        setAmount(0);
        modalCashCalculator.toggle();
    };

    const onChangeValue = (value: number) => {
        setAmount(value);
        if (value > total) {
            setChange(value - total);
        } else {
            setChange(0);
        }
    };

    const handleOnContinue = () => {
        handleClose();
        onContinue();
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalCashCalculator.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-calculator-title"
            aria-describedby="modal-calculator-description"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="modal-calculator-title">
                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack alignItems="center" spacing={2}>
                    <Typography>{`Monto a cobrar: ${currencyFormatter(total)}`}</Typography>
                    <Typography variant="h3" fontWeight={600}>
                        {currencyFormatter(amount)}
                    </Typography>
                    <Typography variant="body1">{`Cambio: ${change.toFixed(2)}`}</Typography>
                    <Calculator showAmount={false} disabled={totalAmount} onChangeValue={onChangeValue} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={amount < total}
                    fullWidth
                    onClick={handleOnContinue}
                    color="success"
                    variant="contained"
                >
                    Ingresar pedido
                </Button>
            </DialogActions>
        </Dialog>
    );
};
